import { render, staticRenderFns } from "./topPage.vue?vue&type=template&id=1505c14e&scoped=true"
import script from "./topPage.vue?vue&type=script&lang=js"
export * from "./topPage.vue?vue&type=script&lang=js"
import style0 from "./topPage.vue?vue&type=style&index=0&id=1505c14e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1505c14e",
  null
  
)

export default component.exports